import { ChartDonut, PIE_CHART_COLORS } from '../../../Chart'

import * as styles from './StatisticChartTab.module.css'

function StatisticChartTab({ allCount, colors = PIE_CHART_COLORS, data }) {
  return (
    <div className={styles.chart}>
      <ChartDonut colors={colors} items={data} total={allCount} />
    </div>
  )
}

export default StatisticChartTab
